import FriendRequest from "./FriendRequest";
export default FriendRequest;
